import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { WidgetsComponent } from './widgets.component'
import { BookingWidgetComponent } from './booking-widget/booking-widget.component'
import { SearchWidgetComponent } from './search-widget/search-widget.component'
import { InquiryWidgetComponent } from './inquiry-widget/inquiry-widget.component'
import { CalendarWidgetComponent } from './calendar-widget/calendar-widget.component'
import { SharedModule } from '@tv3/shared/shared.module'
import { WidgetsRoutingModule } from '@tv3/containers/widgets/widgets-routing.module'
import { ClipboardModule } from 'ngx-clipboard'
import { InterstitialWidgetComponent } from '@tv3/containers/widgets/interstitial-widget/interstitial-widget.component'

@NgModule({
  imports: [CommonModule, SharedModule, WidgetsRoutingModule, ClipboardModule],
  declarations: [
    WidgetsComponent,
    BookingWidgetComponent,
    SearchWidgetComponent,
    InquiryWidgetComponent,
    CalendarWidgetComponent,
    InterstitialWidgetComponent,
  ],
})
export class WidgetsModule {}
